export const media = {
  modal: {
    remove: {
      content: `Are you sure you want to delete the file <b>{description}<b>?`
    }
  },

  list: {
    button_upload: 'Upload file',
    add_media: 'Add media files'
  },

  table: {
    field: {
      play: 'Play',
      created_at: 'Uploaded at'
    }
  }
};
